import Link from "next/link";

// Shown on Aditya Lens routes while Lens is out of scope for the current
// Aditya Labs AI-agent private pilot. No download, purchase, or absolute claims.
export default function LensOutOfScopeNotice() {
  return (
    <main
      style={{
        minHeight: "100vh",
        background: "#08081a",
        color: "#e6edf3",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
      }}
    >
      <div style={{ maxWidth: 640, textAlign: "center" }}>
        <div style={{ fontSize: "1.3rem", fontWeight: 800, color: "#c4a265", letterSpacing: 1, marginBottom: 16 }}>
          ADITYA LENS
        </div>
        <h1 style={{ fontSize: "1.6rem", fontWeight: 700, marginBottom: 16 }}>
          Not part of the current private pilot
        </h1>
        <p style={{ color: "#8b8ba0", lineHeight: 1.7, marginBottom: 24 }}>
          Aditya Lens is not part of the current Aditya Labs AI-agent private pilot. This page is
          retained for future product planning and should not be treated as an active launch offer.
          There is nothing to download or purchase here at this time.
        </p>
        <p style={{ color: "#8b8ba0", lineHeight: 1.7, marginBottom: 24 }}>
          To register interest, please use the contact link on the Aditya Labs homepage.
        </p>
        <Link href="/" style={{ color: "#c4a265", textDecoration: "none", fontWeight: 600 }}>
          &larr; Back to Aditya Labs
        </Link>
      </div>
    </main>
  );
}
